// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".targets-dropdown{z-index:22}", "",{"version":3,"sources":["webpack://./pods/components/dropdowns/targets-dropdown/styles.scss"],"names":[],"mappings":"AAAA,kBACE,UAAA","sourcesContent":[".targets-dropdown {\n  z-index: 22; //SG-41474 display dropdown over the minichat window\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
